module.exports = __webpack_public_path__ + "static/media/golf5.7c29a2e1.jpg";